import React from "react";
import { Link } from "gatsby";
import { GatsbyImage } from "gatsby-plugin-image";

const Card = ({ article }) => {
  // console.log('render');
  return (
    <Link to={`/article/${article.node.slug}`} className="uk-link-reset">
      <div className="uk-card uk-card-muted">
        <div className="uk-card-media-top">
          <GatsbyImage
            image={article?.node?.image?.localFile?.childImageSharp?.gatsbyImageData}
            alt={`Hero image`}
          />
        </div>
      </div>
    </Link>
  );
};

export default Card;
